import { Center, Grid } from '@chakra-ui/react'
import SummaryIconFirst, { SummaryIconRevison, SummaryIconSubmitted} from 'icons/pc-project-icons'
import React from 'react'
import { useWorkOrderCards } from 'api/pc-projects'
import { TicketCard } from './ticket-cards'
import { ContactFirstIcon, ContactSecondIcon, ApprovedIcon, RejectedIcon } from 'icons/work-order-filter-icons'
import { BiAlarm, BiBlock, BiCalendar, BiCheckCircle, BiDetail, BiFlag} from 'react-icons/bi'
//import { AiOutlineFileDone} from 'react-icons/ai'
 
 
import { RiFileReduceLine } from 'react-icons/ri'

const IconElement: React.FC<{ Icon: React.ElementType; bg: string }> = ({ Icon, bg }) => {
  return (
    <Center bg={bg} rounded="50%" w={{ base: '40px', md: '48px' }} h={{ base: '40px', md: '48px' }}>
      <Icon  size={21}/>
    </Center>
  )
}

const useTicketsCardJson = cards => {
  return [
    {
      id: 'draft',
      title: 'Draft',
      value: 'draft',
      number: cards?.find(c => c.status === 6202)?.count || 0,
      IconElement: <IconElement Icon={SummaryIconFirst} bg="#F9F1DA" />,
    },
    {
      id: 'new',
      title: 'New',
      value: 'new',
      number: cards?.find(c => c.status === 1020)?.count || 0,
      IconElement: <IconElement Icon={SummaryIconFirst} bg="#F9F1DA" />,
    },
    
    {
      id: 'contact1',
      title: 'Contact 1',
      value: 'contact1',
      number: cards?.find(c => c.status === 6200)?.count || 0,
      IconElement: <IconElement Icon={ContactFirstIcon} bg="#FFF5F7" />,
    },
    {
      id: 'contact2',
      title: 'Contact 2',
      value: 'contact2',
      number: cards?.find(c => c.status === 6201)?.count || 0,
      IconElement: <IconElement Icon={ContactSecondIcon} bg="#FFE4D0" />,
    },
    {
      id: 'scheduled',
      title: 'Scheduled',
      value: 'scheduled',
      number: cards?.find(c => c.status === 1021)?.count || 0,
      IconElement: <IconElement Icon={BiCalendar} bg="#F5E2F8" />,
    },
    {
      id: 'estimated',
      title: 'Estimated',
      value: 'estimated',
      number: cards?.find(c => c.status === 1022)?.count || 0,
      IconElement: <IconElement Icon={BiAlarm} bg="#E7E7E7" />,
    },

    {
      id: 'submitted',
      title: 'Submitted',
      value: 'submitted',
      number: cards?.find(c => c.status === 1024)?.count || 0,
      IconElement: <IconElement Icon={SummaryIconSubmitted} bg="#F8FFEC" />,
    },
    {
      id: 'approved',
      title: 'Approved',
      value: 'approved',
      number: cards?.find(c => c.status === 1023)?.count || 0,
      IconElement: <IconElement Icon={ApprovedIcon} bg="#E7F0FF" />,
    },
    /*{
      id: 'Completed',
      title: 'Completed',
      value: 'completed',
      number: cards?.find(c => c.status === 34)?.count || 0,
      IconElement: <IconElement Icon={AiOutlineFileDone} bg="#D7FFB8" />,
    },*/
    {
      id: 'closed',
      title: 'Closed',
      value: 'closed',
      number: cards?.find(c => c.status === 36)?.count || 0,
      IconElement: <IconElement Icon={BiCheckCircle} bg="#D7FFE8" />,
    },
    {
      id: 'rejected',
      title: "Rejected",
      value: 'rejected',
      number: cards?.find(c => c.status === 111)?.count || 0,
      IconElement: <IconElement Icon={RejectedIcon} bg="#EBF8FF" />,
    },
    {
      id: 'invoiced',
      title: 'Invoiced',
      value: 'invoiced',
      number: cards?.find(c => c.status === 110)?.count || 0,
      IconElement: <IconElement Icon={BiDetail} bg="#F0FFEC" />,
    },
    {
      id: 'revision',
      title: 'Revision',
      value: 'revision',
      number: cards?.find(c => c.status === 1025)?.count || 0,
      IconElement: <IconElement Icon={SummaryIconRevison} bg="#FAFFBF" />,
    },
    {
      id: 'declined',
      title: 'Declined',
      value: 'declined',
      number: cards?.find(c => c.status === 92)?.count || 0,
      IconElement: <IconElement Icon={RiFileReduceLine} bg="#FFF5F7" />,
    },
    {
      id: 'disputed',
      title: 'Disputed',
      value: 'disputed',
      number: cards?.find(c => c.status === 220)?.count || 0,
      IconElement: <IconElement Icon={BiBlock} bg="#F5E2F8" />,
    },
    {
      id: 'flagged',
      title: 'Flagged',
      value: 'flagged',
      number: cards?.find(c => c.status === 1)?.count || 0,
      IconElement: <IconElement Icon={BiFlag} bg="#FFE1E1" />,
    }
  ]
}

export type TicketCardProps = {
  onSelectCard: (string) => void
  selectedCard: string
  selectedFPM?: any
  clear?: any
}

export const TicketFilters: React.FC<TicketCardProps> = ({ onSelectCard, selectedCard, selectedFPM, clear }) => {
  const { data: values, isLoading } = useWorkOrderCards(selectedFPM?.id)
  const cards = useTicketsCardJson(values)

  return (
    <>
      <Grid gap={3} gridTemplateColumns="repeat(auto-fit,minmax(230px,1fr))">
        {cards.map(card => {
          return (
            <TicketCard
              key={card.id}
              {...card}
              onSelectCard={onSelectCard}
              selectedCard={selectedCard}
              isLoading={isLoading}
              clear={clear}
            />
          )
        })}
      </Grid>
    </>
  )
}
